export const sidePanelActions = (state, dispatch, props) => {
  function updateSidePanel(sidePanelData) {
    dispatch({ type: "SIDEPANEL_UPDATE", payload: sidePanelData });
  }

  return {
    updateSidePanel,
  };
};
